import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Product", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Get to Know Us", to: "/about" },
  { label: "Career Path", to: "/careers" },
];

const tid = (label) => `nav-link-${label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`;

export const Navbar = ({ onContact }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [pathname]);

  return (
    <nav className={`mac-nav ${scrolled || menuOpen ? "scrolled" : ""}`} data-testid="navbar">
      <div className="mac-container">
        <div className="mac-nav-inner">
          <Link to="/" className="mac-logo-slot" data-testid="nav-logo-slot" style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 10 }}>
            <img src="https://customer-assets-4nw71qhi.emergentagent.net/job_macaron-ai-launch/artifacts/fo1ztu3b_Macaron.png" alt="The Macaron AI" className="mac-logo-mark" />
            THE MACARON AI
          </Link>

          <div className="hidden md:flex items-center" style={{ gap: 32 }}>
            {links.map((l, i) => (
              <Link
                key={i}
                to={l.to}
                className="mac-nav-link"
                data-testid={tid(l.label)}
                style={{ color: pathname === l.to ? "#e5007d" : undefined, textDecoration: "none" }}
              >
                {l.label}
              </Link>
            ))}
            <button className="mac-btn mac-btn-nav" data-testid="nav-contact-btn" onClick={onContact}>
              Contact Us
            </button>
          </div>

          <button
            className="md:hidden mac-nav-link"
            data-testid="nav-menu-toggle"
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {menuOpen && (
          <div className="mac-mobile-menu md:hidden" data-testid="mobile-menu">
            {links.map((l, i) => (
              <Link
                key={i}
                to={l.to}
                className="mac-nav-link"
                data-testid={`${tid(l.label)}-mobile`}
                style={{ color: pathname === l.to ? "#e5007d" : undefined, textDecoration: "none", padding: "10px 0" }}
              >
                {l.label}
              </Link>
            ))}
            <button
              className="mac-btn mac-btn-nav"
              style={{ marginTop: 10, width: "fit-content" }}
              data-testid="nav-contact-btn-mobile"
              onClick={() => { setMenuOpen(false); onContact(); }}
            >
              Contact Us
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};
